var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ckeditor"},[_c('textarea',{attrs:{"id":_vm.id},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }